import React from 'react';

export const DashboardPage = () => {

    // const style = {
    //     "aspect-ratio": "1 / 1"
    // };
    // const [query, setQuery] = useState('');
    // const [products, setProducts] = useState([]);


    // const fetchData = async (query) => {
    //     const url = query ? `${process.env.REACT_APP_API_URL}/store_products?search=${query}` : `${process.env.REACT_APP_API_URL}/store_products`;
    //     console.log(url);
    //     let response = await (
    //       await fetch(url)
    //     ).json();
    //     console.log("response", response?.data);
    //     setProducts(response?.data || []);
    // };

    // const numberFormat = (value) =>
    //     new Intl.NumberFormat('en-IN', {
    //         style: 'currency',
    //         currency: 'USD'
    //     }).format(value);

    // useEffect(() => {
    //     fetchData(query)
    // }, [query])
    

    // return (
    //     <>
    //         <section>
    //             <header class="mb-4 d-flex">
    //                 <h3>Tenis bubble gummers</h3> 
    //                 <TextField 
    //                   size="small"
    //                   variant="outlined"
    //                   placeholder="Buscar producto"
    //                   style={{minWidth: '25%', marginLeft: 'auto'}}
    //                   onChange={(e) => {
    //                     setQuery(e.target.value);
    //                   }}
    //                 />
    //             </header>
    //             <div className="row">
    //                 {
    //                     (products && products.length > 0) ? products.map(product => (<div class="col-lg-3 col-md-6 col-sm-6">
    //                     <div class="card my-2 shadow-0">
    //                         <div class="img-wrap"> 
    //                             <img src="https://bootstrap-ecommerce.com/bootstrap5-ecommerce/images/items/11.webp" class="card-img-top" style={style}/> 
    //                         </div>
    //                         <hr />
    //                         <div class="card-body p-0 p-3">
    //                             <h3>Producto: {product?.attributes?.product_name}</h3>
    //                             <h4>Marca: {product?.attributes?.brand}</h4>
    //                             <p class="card-title">Precio: {numberFormat(product?.attributes?.public_price)}</p>
    //                             <small class="card-text mb-0">{product?.attributes?.description}</small>
    //                             <br />
    //                             <span class="text-muted">
    //                                 Colores:
    //                             </span>
    //                             <div style={{ maxWidth: 'inherit'}}>
    //                                 {product?.attributes?.details?.map(detail => (
    //                                     <div>
    //                                         <small>{detail?.color}</small>
    //                                         <div style={{ display: 'flex' }}>
    //                                             {
    //                                                 detail?.stock?.map(s => (
    //                                                     <div style={{ 
    //                                                         margin: '0.2em 0.3em', 
    //                                                         border: `2px solid ${s?.amount > 0 ? '#1ABC9C' : '#C0392B'}`, 
    //                                                         padding: '0.2em', 
    //                                                         borderRadius: '15%', 
    //                                                         backgroundColor: s?.amount > 0 ? '#73C6B6' : '#F08080',
    //                                                         color: 'white'
    //                                                     }}>
    //                                                         {s?.size}
    //                                                     </div>
    //                                                 ))
    //                                             }
    //                                         </div>
    //                                     </div>
    //                                 ))}
    //                             </div>
    //                         </div>
    //                     </div>       
    //                 </div>)) : <p>Cargando...</p>
    //                 }
                                                     
    //             </div>       
    //         </section>
    //     </>
    // )
    return (<>
        <h1>Hola </h1>
    </>);
};